<div *ngIf="loader1 || pageLoading2" class="loader text-center">
	<img src="../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
<header id="main-menu-header" class="header fixed-top d-flex align-items-center">
	<div class="d-flex align-items-center justify-content-between">
		<a [routerLink]="[homeUrl]" class="logo d-flex align-items-center">
			<img src="../assets/img/3Cube-dark.png" alt="">
		</a>
	</div>
	<mat-toolbar style="background: none;">
		<a mat-button [routerLink]="[homeUrl]" [routerLinkActive]="'menu-active'" matTooltip="Home">
			<fa-icon [icon]="['fas','home']" class="fs-16"></fa-icon>
		</a>
		<a mat-button [routerLinkActive]="'menu-active'" [routerLink]="['/app/list-appointment']"
			matTooltip="Appointments">
			<fa-icon [icon]="['fas','calendar-alt']" class="fs-16"></fa-icon>
		</a>
		<button mat-button [ngbPopover]="popContent1" placement="bottom" popoverClass="popup-menu" matTooltip="Menu">
			<fa-icon [icon]="['fas','th']" class="fs-16"></fa-icon>
		</button>
		<ng-template #popContent1>
			<div class="row fixHeightMenu">
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item"
					[routerLink]="['/app/mailbox/folder/unlinked']" [class.popup-menu-active]="isActive('app/mailbox')">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','envelope']"></fa-icon>
						<br />
						Mailbox
					</p>
				</a>
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item"
					[routerLink]="['/app/registered-candidates']" [class.popup-menu-active]="isActive('app/registered-candidates')">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','user-tie']"></fa-icon>
						<br />
						Registered Candidates
					</p>
				</a>
				@if (userAccess?.Hospital_Master=='Full' || userAccess?.Hospital_Master=='Readonly') {
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item"
					[routerLink]="['/app/masters/hospitals']" [routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','hospital']"></fa-icon>
						<br />
						Hospitals
					</p>
				</a>
				}
				@if (userAccess?.Doctor_Master=='Full' || userAccess?.Doctor_Master=='Readonly') {
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/masters/doctors']"
					[routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','user-md']"></fa-icon>
						<br />
						Doctors
					</p>
				</a>
				}
				@if (userAccess?.Medicine_Master=='Full' || userAccess?.Medicine_Master=='Readonly') {
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item"
					[routerLink]="['/app/masters/medicines']" [routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','medkit']"></fa-icon>
						<br />
						Medicines
					</p>
				</a>
				}
				@if (userAccess?.Lab_Test_Master=='Full' || userAccess?.Lab_Test_Master=='Readonly') {
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item"
					[routerLink]="['/app/masters/labtests']" [routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','flask']"></fa-icon>
						<br />
						Lab Tests
					</p>
				</a>
				}
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/masters/vessels']"
					[routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','ship']"></fa-icon>
						<br />
						Vessels
					</p>
				</a>
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/masters/ranks']"
					[routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','star']"></fa-icon>
						<br />
						Ranks
					</p>
				</a>
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item"
					[routerLink]="['/app/masters/companies']" [routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','building']"></fa-icon>
						<br />
						Companies
					</p>
				</a>
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/masters/users']"
					[routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','users']"></fa-icon>
						<br />
						Users
					</p>
				</a>
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/call-list']"
					[routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','phone']"></fa-icon>
						<br />
						Calls
					</p>
				</a>
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/treatment-costs']"
					[routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','file-invoice']"></fa-icon>
						<br />
						Quotations
					</p>
				</a>
				<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/masters/mail-templates']"
					[routerLinkActive]="'popup-menu-active'">
					<p class="sub-menu-p">
						<fa-icon [icon]="['fas','list']"></fa-icon>
						<br />
						Mail Templates
					</p>
				</a>
			</div>
		</ng-template>
		<button mat-button matTooltip="Handover" (click)="openHandoverModal()">
			<fa-icon [icon]="['fas','handshake']" class="fs-16"></fa-icon>
		</button>
		<button mat-button matTooltip="Dashboard View" (click)="openDashboardSettingModal()">
			<fa-icon [icon]="['fas','cog']" class="fs-16"></fa-icon>
		</button>
	</mat-toolbar>
	<nav class="header-nav ms-auto">
		<ul class="d-flex align-items-center">
			<li class="nav-item dropdown pe-3">
				<a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
					<img src="../assets/img/profile-img.png" alt="Profile" class="rounded-circle">
					<span class="d-none d-md-block dropdown-toggle ps-2">
						{{user?.first_name}} {{user?.last_name}}
					</span>
				</a>
				<ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
					<li class="dropdown-header">
						<h6>
							{{user?.first_name}} {{user?.last_name}}
						</h6>
					</li>
					<li>
						<hr class="dropdown-divider">
					</li>
					<li>
						<a class="dropdown-item d-flex align-items-center" style="cursor: pointer;"
							(click)="logoutUser()">
							<fa-icon [icon]="['fas','sign-out-alt']" class="me-2"></fa-icon>
							<span>Sign Out</span>
						</a>
						<a class="dropdown-item d-flex align-items-center" style="cursor: pointer;"
							(click)="openMFAModal()">
							<fa-icon [icon]="['fas','user-shield']" class="me-2"></fa-icon>
							<span>Manage MFA</span>
						</a>
						<a class="dropdown-item d-flex align-items-center" style="cursor: pointer;"
							(click)="openUserModal()">
							<fa-icon [icon]="['fas','signature']" class="me-2"></fa-icon>
							<span>Email Signature</span>
						</a>
					</li>
				</ul>
			</li>
		</ul>
	</nav>
</header>
<main id="page-content-container-common" class="main" [@routeAnimations]="prepareRoute(o)">
	<router-outlet #o="outlet"></router-outlet>
</main>
<br />
<footer id="footer" class="footer fixed-bottom bg-light">
	<div class="row g-0">
		<div class="col"></div>
		<div class="col">
			<div class="copyright">
				&copy; Copyright <strong><span>3CubeMedicare</span></strong>.
				&nbsp;All Rights Reserved
			</div>
		</div>
		<div class="col">
			<fa-icon *ngIf="showScrollBtn" [icon]="['fas', 'angle-double-up']" (click)="scrollToTop()"
				matTooltip="Scroll to top" [matTooltipPosition]="'left'" class="float-end me-2" role="button"></fa-icon>
		</div>
	</div>
</footer>
<div class="modal fade" id="allHandoverModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">
					<strong>
						Handover
					</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<table class="table table-bordered table-striped table-hover">
					<thead>
						<tr>
							<th style="width: 20%;">Case Id</th>
							<th style="width: 70%;">Notes</th>
							<th style="width: 10%;">Done</th>
						</tr>
					</thead>
					<tbody>
						@for (handover of handovers; track $index) {
						<tr>
							<td>
								<a [routerLink]="['/app/appt-details','no', handover.enc_case_id, handover.enc_id]"
									data-bs-dismiss="modal">
									{{handover.case_id}}
								</a>
							</td>
							<td [innerHTML]="handover.opd_notes | safeHtml"></td>
							<td>
								<button type="button" class="btn btn-xs btn-success" (click)="doneHandover(handover)">
									<fa-icon *ngIf="doneLoader !== handover.id" [icon]="['fas','check']"></fa-icon>
									<fa-icon *ngIf="doneLoader === handover.id" [icon]="['fas','spinner']"
										[animation]="'spin'"></fa-icon>
								</button>
							</td>
						</tr>
						}
					</tbody>
				</table>
				<p class="mb-0 text-center">
					<ng-container *ngIf="handoverLoader">
						<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
						Loading...
					</ng-container>
					<ng-container *ngIf="!handoverLoader && !handovers.length">
						No data found
					</ng-container>
				</p>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="getHandover()"
					[disabled]="handoverLoader">
					Refresh
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="dashboardSettingsModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">
					<strong>
						Dashboard View
					</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row border-bottom">
					<div class="col-12">
						<mat-checkbox [color]="'primary'" [(ngModel)]="selectAll" (change)="check_uncheck_all()">
							Select All
						</mat-checkbox>
					</div>
				</div>
				<div class="row">
					@for (view of viewList; track $index) {
					<div class="col-6">
						<mat-checkbox [color]="'primary'" [(ngModel)]="view.selected" (change)="check_uncheck()">
							{{view.name}}
							@if(showInfo){
							<fa-icon [icon]="['fas','info']" [matTooltip]="view.tooltip">
							</fa-icon>
							}
						</mat-checkbox>
					</div>
					}
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveDashboardSetting()"
					[disabled]="saveDashSettingLoader">
					@if (saveDashSettingLoader) {
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					}@else {
					<fa-icon [icon]="['fas','save']"></fa-icon>
					}
					Save
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="userModalNavbar" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-xl">
		@if (user) {
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">
					<strong>
						Email Signature
					</strong>
				</h4>
				<button type="button" class="btn-close" (click)="closeSignModal();"></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col">
						<quill-editor [(ngModel)]="user.email_signature" [modules]="quillConfig"
							[placeholder]="'Email Signature'">
						</quill-editor>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveUserSignature()"
					[disabled]="showLoader || existing_signature == user.email_signature">
					@if (showLoader) {
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					}@else {
					<fa-icon [icon]="['fas','save']"></fa-icon>
					}
					Save
				</button>
				<button type="button" class="btn btn-sm btn-warning" (click)="closeSignModal();">
					Close
				</button>
			</div>
		</div>
		}
	</div>
</div>
<!-- <div class="modal fade" id="mfaModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">Multi-Factor Authentication</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				@if (hide_mfa) {
				<p>Sorry, MFA is not avaible for this account.</p>
				}@else {
				<ng-toggle [(ngModel)]="mfa_enabled" [color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
					[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
					[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
					[labels]="{'unchecked': 'Disabled','checked': 'Enabled'}" [width]="100"
					(change)="changeMFAStatus()"></ng-toggle>
				}
				@if (showMFAForm1) {
				<form [formGroup]="mfaForm1" (ngSubmit)="submitMFAPassword()" #mfaform1="ngForm">
					<div class="row">
						<div class="col-sm-4">
							<label class="mt-2 mb-1">
								<span class="text-danger">*</span>
								Enter your password:
							</label>
							<input placeholder="Password" type="password" formControlName="password"
								class="form-control" />
							@if (f1.password.errors && (mfaform1.submitted || f1.password.touched)){
							<small class="text-danger">
								@if (f1.password.errors.required) {
								<span>
									Required
								</span>
								}
								@if (f1.password.errors.wrong_password) {
								<span>
									Invalid password
								</span>
								}
							</small>
							}
						</div>
					</div>
					<div class="row">
						<div class="col-sm-4">
							<button type="submit" class="btn btn-sm btn-success mt-2">
								Submit
							</button>
						</div>
					</div>
				</form>
				}
				@if (showMFAForm2) {
				<form [formGroup]="mfaForm2" (ngSubmit)="verifyMFA()" #mfaform2="ngForm">
					<div class="row">
						<div class="col-sm-4">
							<div class="row">
								<div class="col-sm-12">
									<label class="mt-2 mb-1">
										<span class="text-danger">*</span>
										Enter code from authenticator app:
									</label>
									<input placeholder="Code" type="password" formControlName="user_code"
										class="form-control" />
									@if (f2.user_code.errors && (mfaform2.submitted ||
									f2.user_code.touched)){
									<small class="text-danger">
										@if (f2.user_code.errors.required) {
										<span>
											Required
										</span>
										}
										@if (f2.user_code.errors.pattern) {
										<span>
											Invalid
										</span>
										}
										@if (f2.user_code.errors.wrong_password) {
										<span>
											Invalid
										</span>
										}
									</small>
									}
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									<button type="submit" class="btn btn-sm btn-success mt-2">
										Submit
									</button>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12 text-center">
									@if (qr_code) {
									<img [src]="qr_code" alt="QR Code" style="width: 100%;height: auto;" />
									}
								</div>
							</div>
						</div>
						<div class="col-sm-8">
							<div class="row">
								<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
									<h3>Set Up Google Authenticator App</h3>
									<h4>
										<div class="my-circle">1</div>
										Download an App
									</h4>
									<p style="padding-left: 30px;">
										Download the Google Authenticator App from&nbsp;
										<a href="https://play.google.com" target="_blank">
											Google Play Store
										</a>
										&nbsp;or&nbsp;
										<a href="https://apps.apple.com" target="_blank">
											App Store
										</a>
									</p>
								</div>
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 text-center">
									<div class="app-icon-container">
										<a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
											target="_blank" style="margin-top: 30px;">
											<img src="../assets/img/get_it_on_google_play.png"
												style="width: 90%;height: auto;" />
										</a>
										<a href="https://apps.apple.com/us/app/google-authenticator/id388497605"
											target="_blank">
											<img src="../assets/img/download_on_app_store.png"
												style="width: 90%;height: auto;margin-top: 10px;" />
										</a>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
									<h3>Set Up Google Authenticator App</h3>
									<h4>
										<div class="my-circle">2</div>
										Add Your Account
									</h4>
									<p style="padding-left: 30px;">
										Scan the QR code to get the code you will need to complete
										the
										verification in step 3 and to verify future logins.
									</p>
									<h4>
										<div class="my-circle">3</div>
										Verify Your Account
									</h4>
									<p style="padding-left: 30px;">
										Enter the 6 digit code provided from your authenticator app.
									</p>
								</div>
							</div>
						</div>
					</div>
				</form>
				}
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div> -->
<div class="modal fade modern-modal-wrapper" id="mfaModal" role="dialog">
	<div class="modal-dialog modal-lg modern-modal-dialog mfa-modal-dialog">
		<div class="modal-content modern-modal-content">
			<div class="modal-header modern-modal-header">
				<h4 class="modal-title">Multi-Factor Authentication</h4>
				<button type="button" class="btn-close modern-btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body modern-modal-body">
				@if (hide_mfa) {
				<p>Sorry, MFA is not avaible for this account.</p>
				}@else {
				<div class="mfa-toggle-container">
					<div class="toggle-label">
						<fa-icon [icon]="['fas', 'shield-alt']"></fa-icon>
						<span>Enable Two-Factor Authentication</span>
					</div>
					<label class="modern-custom-switch">
						<input type="checkbox" [(ngModel)]="mfa_enabled" (change)="changeMFAStatus()">
						<span class="switch-slider"></span>
					</label>
				</div>
				}
				@if (showMFAForm1) {
				<form [formGroup]="mfaForm1" (ngSubmit)="submitMFAPassword()" #mfaform1="ngForm">
					<div class="row">
						<div class="col-sm-5">
							<label class="mt-2 mb-1 modern-label">
								<span class="text-danger">*</span>
								Enter your password:
							</label>
							<input placeholder="Password" type="password" formControlName="password"
								class="form-control modern-input" />
							@if (f1.password.errors && (mfaform1.submitted || f1.password.touched)){
							<small class="text-danger">
								@if (f1.password.errors.required) {
								<span>
									Required
								</span>
								}
								@if (f1.password.errors.wrong_password) {
								<span>
									Invalid password
								</span>
								}
							</small>
							}
						</div>
					</div>
					<div class="row">
						<div class="col-sm-5">
							<button type="submit" class="btn modern-btn modern-btn-primary mt-3">
								Submit
							</button>
						</div>
					</div>
				</form>
				}
				@if (showMFAForm2) {
				<form [formGroup]="mfaForm2" (ngSubmit)="verifyMFA()" #mfaform2="ngForm">
					<div class="row">
						<div class="col-sm-5">
							<div class="row">
								<div class="col-sm-12">
									<label class="mt-2 mb-1 modern-label">
										<span class="text-danger">*</span>
										Enter code from authenticator app:
									</label>
									<input placeholder="Code" type="password" formControlName="user_code"
										class="form-control modern-input" />
									@if (f2.user_code.errors && (mfaform2.submitted ||
									f2.user_code.touched)){
									<small class="text-danger">
										@if (f2.user_code.errors.required) {
										<span>
											Required
										</span>
										}
										@if (f2.user_code.errors.pattern) {
										<span>
											Invalid
										</span>
										}
										@if (f2.user_code.errors.wrong_password) {
										<span>
											Invalid
										</span>
										}
									</small>
									}
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12 mt-3">
									<button type="submit" class="btn modern-btn modern-btn-primary">
										Submit
									</button>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12 text-center mt-4">
									@if (qr_code) {
									<div class="qr-container">
										<img [src]="qr_code" alt="QR Code" class="qr-image" />
									</div>
									}
								</div>
							</div>
						</div>
						<div class="col-sm-7">
							<div class="mfa-setup-card">
								<h3 class="mfa-setup-title">Set Up Google Authenticator</h3>

								<div class="mfa-step">
									<div class="mfa-step-number">1</div>
									<div class="mfa-step-content">
										<h4 class="mfa-step-title">Download the App</h4>
										<p class="mfa-step-desc">
											Get the Google Authenticator app from the
											<a href="https://play.google.com" target="_blank">Google Play Store</a> or
											<a href="https://apps.apple.com" target="_blank">App Store</a>.
										</p>
										<div class="mfa-app-links">
											<a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
												target="_blank" class="app-link">
												<img src="../assets/img/get_it_on_google_play.png" alt="Google Play" />
											</a>
											<a href="https://apps.apple.com/us/app/google-authenticator/id388497605"
												target="_blank" class="app-link">
												<img src="../assets/img/download_on_app_store.png" alt="App Store" />
											</a>
										</div>
									</div>
								</div>

								<div class="mfa-step">
									<div class="mfa-step-number">2</div>
									<div class="mfa-step-content">
										<h4 class="mfa-step-title">Add Your Account</h4>
										<p class="mfa-step-desc">
											Scan the QR code shown on the left to link your account. This will generate
											the codes needed for step 3 and future logins.
										</p>
									</div>
								</div>

								<div class="mfa-step">
									<div class="mfa-step-number">3</div>
									<div class="mfa-step-content">
										<h4 class="mfa-step-title">Verify Your Account</h4>
										<p class="mfa-step-desc">
											Enter the 6-digit code provided by your authenticator app in the input field
											on the left.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
				}
			</div>
			<div class="modal-footer modern-modal-footer">
				<button type="button" class="btn modern-btn modern-btn-outline" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>